import { IRouteConfig, PermissionKeys } from '../shared';
import { ReportRegistrations } from './pages';

export const registrationsRoutes: IRouteConfig[] = [
    { path: '/registrations', component: ReportRegistrations, requiredPermissions: PermissionKeys.REGISTRATIONS_READ },
];
